import { render, staticRenderFns } from "./questionDescription.vue?vue&type=template&id=3343539c&scoped=true"
import script from "./questionDescription.vue?vue&type=script&lang=js"
export * from "./questionDescription.vue?vue&type=script&lang=js"
import style0 from "./questionDescription.vue?vue&type=style&index=0&id=3343539c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3343539c",
  null
  
)

export default component.exports